import userDataAPI from '../../APIs/LoginAPI/UserDataAPI'

export const getUserData = {
    state: {
        getUserInfo: null,
        getPrincipal: null,
        getUserDependent: null,
        userForgotPasswordCred: null,
        userAccountCred: null,
        succChangePass: '',
        errChangePass: ''
    },
    actions: {
        // User Information
        async userInfo({ commit }, userCredentials) {
            await userDataAPI
                .userInfo(userCredentials)
                .then(res => {
                    commit('USER_INFO', res.data)
                })
                .catch(async error => {
                    if (error.response.status == 401) {
                        // console.error(error);
                    }
                })
        },

        // User (PRINCIPAL) Dependents
        userDependent({ commit }, userCredentials) {
            userDataAPI
                .userDependent(userCredentials)
                .then(res => {
                    commit('USER_DEPENDENT', res.data)
                })
                .catch(async error => {
                    if (error.response.status == 401) {
                        // console.error(error);
                    } else if (error.response.status == 404) {
                        commit('USER_DEPENDENT', error.response.data)
                    }
                })
        },

        // For getting PRINCIPAL when DEPENDENT logs in
        retrievePrincipal({ commit }, userCredentials) {
            userDataAPI
                .userInfo(userCredentials)
                .then(res => {
                    commit('DEPENDENT_PRINCIPAL', res.data)
                })
                .catch(async error => {
                    if (error.response.status == 401) {
                        // console.error(error);
                    }
                })
        },

        // -------------------------------------------------------------------------------------------------
        // User Manage Account
        // Call email add and cp no initially when on manage account page
        userAccountCred({ commit }, userCredentials) {
            userDataAPI
                .userAccountCred(userCredentials)
                .then(res => {
                    commit('USER_ACCOUNT_CRED', res.data)
                })
                .catch(async error => {
                    if (error.response.status == 401) {
                        // console.error(error);
                    }
                })
        },

        // Update Email
        manageAccountEmail(_, userCredentials) {
            userDataAPI.manageAccountEmail(userCredentials)
        },
        // Update Cp #
        manageAccountCPno(_, userCredentials) {
            userDataAPI.manageAccountCPno(userCredentials)
        },
        // Update Address
        manageAccountAddress(_, userCredentials) {
            userDataAPI.manageAccountAddress(userCredentials)
        },

        // Update Pass #
        async manageAccountPass({ commit }, userCredentials) {
            commit('ERR_CHANGE_PASSWORD', '')
            try {
                const res = await userDataAPI.manageAccountPass(userCredentials)
                if (res.data.CHANGEPASS_MSG != null) {
                    commit('ERR_CHANGE_PASSWORD', res.data.CHANGEPASS_MSG)
                } else {
                    await new Promise(resolve => {
                        window.setTimeout(() => {
                            commit('CHANGE_PASSWORD', 'Success! Please wait while page reloads...')
                            commit('ERR_CHANGE_PASSWORD', '')
                            window.setTimeout(() => {
                                window.location.href = '/'
                                resolve()
                            }, 2500)
                        }, 1000)
                    })
                }
                return Promise.resolve()
            } catch (err) {
                return Promise.reject(err)
            }
            // userDataAPI.manageAccountPass(userCredentials).then((res) => {
            //   if (res.data.CHANGEPASS_MSG != null) {
            //     commit("ERR_CHANGE_PASSWORD", res.data.CHANGEPASS_MSG);
            //   } else {
            //     window.setTimeout(() => {
            //       commit(
            //         "CHANGE_PASSWORD",
            //         "Success! Please wait while page reloads..."
            //       );
            //       commit("ERR_CHANGE_PASSWORD", "");
            //       window.setTimeout(() => {
            //         window.location.href = "/";
            //       }, 2500);
            //     }, 1000);
            //   }
            // });
        }
    },
    mutations: {
        USER_INFO(state, getUserInfo) {
            state.getUserInfo = getUserInfo
        },
        USER_DEPENDENT(state, getUserDependent) {
            state.getUserDependent = getUserDependent
        },
        DEPENDENT_PRINCIPAL(state, getPrincipal) {
            state.getPrincipal = getPrincipal
        },
        USER_FORGOT_PASS(state, userForgotPasswordCred) {
            state.userForgotPasswordCred = userForgotPasswordCred
        },

        // For Manage account
        USER_ACCOUNT_CRED(state, userAccountCred) {
            state.userAccountCred = userAccountCred
        },
        CHANGE_PASSWORD(state, succChangePass) {
            state.succChangePass = succChangePass
        },
        ERR_CHANGE_PASSWORD(state, errChangePass) {
            state.errChangePass = errChangePass
        }
    },
    getters: {
        getUserInfo(state) {
            return state.getUserInfo
        },
        getUserDependent(state) {
            return state.getUserDependent
        },
        getPrincipal(state) {
            return state.getPrincipal
        },
        userForgotPasswordCred(state) {
            return state.userForgotPasswordCred
        },

        // For Manage Account
        getAccountEmailCpNo(state) {
            return state.userAccountCred
        },
        succChangePass(state) {
            return state.succChangePass
        },
        errChangePass(state) {
            return state.errChangePass
        }
    }
}
